import { Modal, ModalProps } from 'antd';

interface ModifyShortcutModalProps {
  modalData: ModalProps;
}

export default function ModifyShortcutModal({ modalData }: ModifyShortcutModalProps) {
  return <Modal {...modalData} />;
}
